<div *ngIf="!accepted" class="cookie-popup">
  <p class="cookie-message" i18n="@@cookiePopup.description">By continuing to use this site you agree to our
    <a class="cookie-link" rel=noopener routerLink="{{URLS.cookiePolicy}}" target="_blank">Cookie Policy</a>.
  </p>
  <div (click)="setAccepted()" class="accept">
    <p i18n="@@cookiePopup.button">Agree</p>
  </div>
</div>
